import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const readMessage = async (rid: string): Promise<AxiosResponse> =>
  AxiosInstance.post('subscriptions.read', {
    rid,
  });
